import { makeStyles } from '@material-ui/core/styles'

export const WhatsNewFeedbackStyles = makeStyles((theme) => ({
  feedbackButton: {
    width: '100%',
    maxWidth: 100,
    justifySelf: 'flex-end',
    backgroundColor: theme.palette.base.red,
    color: theme.palette.base.white,
    '&:hover': {
      backgroundColor: theme.palette.base.red,
    },
  },
  feedbackButtonLarge: {
    width: '100%',
    backgroundColor: theme.palette.base.red,
    color: theme.palette.base.white,
    '&:hover': {
      backgroundColor: theme.palette.base.red,
    },
  },
  gridContainer: {
    padding: theme.spacing(4, 2),
  },
  gridItem: {
    height: '100%',
    width: '100%',
  },
  linksCard: {
    padding: theme.spacing(2),
    maxHeight: '400px',
    backgroundColor: theme.palette.backgroundColor.secondary,
  },
  descriptionField: {},
}))
